import { render, staticRenderFns } from "./HomepageApp.vue?vue&type=template&id=7847226b&scoped=true&"
import script from "./HomepageApp.vue?vue&type=script&lang=js&"
export * from "./HomepageApp.vue?vue&type=script&lang=js&"
import style0 from "./HomepageApp.vue?vue&type=style&index=0&id=7847226b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847226b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VApp,VContainer,VFadeTransition})
